import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Consultation } from '../../models/consultation';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: 'app-consultazione-list',
  templateUrl: './consultazione-list.component.html',
  styleUrls: ['./consultazione-list.component.css']
})
export class ConsultazioneListComponent implements OnInit, OnChanges{

  @Input() consultations: any;
  @Output() createEvent: EventEmitter<Consultation> = new EventEmitter<Consultation>;
  consultationsToShow: Consultation[] = [];
  resetCurrentPage: boolean = false;
  currentPage: number = 0;
  itemsPerPage: number = 10;


  ngOnInit(): void {
    if (this.consultations) {
      this.setConsultationsToShow();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!changes.consultations.firstChange){
      this.resetCurrentPage = true;
      this.currentPage = 0;
      // this.itemsPerPage = 10;
      this.setConsultationsToShow();
    }
  }

  onRefresh(event: Pagination) {
    this.currentPage = event.getCurrentPage();
    this.itemsPerPage = event.getItemsPerPage();

    this.setConsultationsToShow();
    this.resetCurrentPage = false;

  }

  onCreate(consultation) {
    this.createEvent.emit(consultation);
  }

  setConsultationsToShow(){
    this.consultationsToShow = this.consultations.slice(this.currentPage*this.itemsPerPage, (this.currentPage+1)*this.itemsPerPage);
  }


}
